import React from 'react';
import { Sun, Moon } from 'lucide-react';
interface ThemeToggleProps {
  isDark: boolean;
  onToggle: () => void;
}
export function ThemeToggle({
  isDark,
  onToggle
}: ThemeToggleProps) {
  return <button onClick={onToggle} className="p-2 text-stone-900 hover:text-brand-orange dark:text-stone-200 dark:hover:text-brand-orange transition-colors focus:outline-none" aria-label="Toggle Dark Mode" data-id="element-1807" data-mp="3h4mk5mfumfk2">
      {isDark ? <Sun className="w-5 h-5" data-id="element-1808" data-mp="2pf06xfgahr5j" /> : <Moon className="w-5 h-5" data-id="element-1809" data-mp="2pfrqfrwm3yfg" />}
    </button>;
}